export const CONTRACT_ADDRESS = "0x3ad0Ce124d2bC425DF282316f1f30297587BFE80";
export const METADATA_BASE_URI = "https://arianoir-io.s3.amazonaws.com";
export const STORE_BASE_URI = "https://www.arianoir.com";
export const API_BASE_URI = "https://www.arianoir.io/api";
